/* =====================================================================
   DANSKO US BEHAVIOUR LAYER (dansko-us.js)
   1. "ADD TO CART • $price" label on the product page button
   2. Sticky add-to-cart bar on product pages (scrolls back to size picker)
   4. Product page: star rating moved next to the price
   5. Product page: EU / US size switch (shared with the quick shop)
   6. Product page: size guide drawer
   Pure progressive enhancement: if this file fails, the page works as normal.
   ===================================================================== */
(function () {
  'use strict';

  var SEP = ' • ';

  function formatMoney(cents, fallback) {
    try {
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
      var locale = document.documentElement.lang || 'en-AU';
      var formatted = new Intl.NumberFormat(locale.indexOf('-') > -1 ? locale : 'en-AU', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
      return formatted;
    } catch (e) {
      return fallback || '';
    }
  }

  /* ---------- 1. ATC price label ---------- */
  function initAtcLabels() {
    var buttons = document.querySelectorAll('.product-form__submit[data-dk-price]');
    buttons.forEach(function (button) {
      var label = button.querySelector('span');
      if (!label || button.dataset.dkBound) return;
      button.dataset.dkBound = 'true';

      var addText = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';

      var apply = function () {
        var text = label.textContent.trim();
        var price = button.dataset.dkPrice;
        if (!price) return;
        if (text === addText.trim()) {
          label.textContent = addText + SEP + price;
        }
      };

      apply();
      new MutationObserver(apply).observe(label, { childList: true, characterData: true, subtree: true });
    });
  }

  function listenForVariantChange() {
    if (typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    window.subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.variant || !data.sectionId) return;
      var button = document.getElementById('ProductSubmitButton-' + data.sectionId);
      if (!button) return;
      button.dataset.dkPrice = formatMoney(data.variant.price, button.dataset.dkPrice);
      var label = button.querySelector('span');
      var addText = (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart';
      if (label && label.textContent.trim().indexOf(addText.trim()) === 0) {
        label.textContent = addText + SEP + button.dataset.dkPrice;
      }
      var sticky = document.querySelector('.dk-sticky-atc__price');
      if (sticky) sticky.textContent = button.dataset.dkPrice;
    });
  }

  /* ---------- 2. Sticky add-to-cart ---------- */
  function initStickyAtc() {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.dk-sticky-atc')) return;

    var mainInfo = document.querySelector('main product-info[id^="ProductInfo-template"]');
    if (!mainInfo) return;
    var mainButton = mainInfo.querySelector('.product-form__submit[data-dk-price]');
    if (!mainButton) return;

    var nameEl = mainInfo.querySelector('.dk-pdp-title__name');
    var colourEl = mainInfo.querySelector('.dk-pdp-title__colour');
    var name = nameEl ? nameEl.textContent.trim() : document.title.split('|')[0].split('–')[0].trim();
    var colour = colourEl ? colourEl.textContent.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'dk-sticky-atc';
    bar.setAttribute('aria-hidden', 'true');

    var info = document.createElement('div');
    info.className = 'dk-sticky-atc__info';
    var n = document.createElement('span');
    n.className = 'dk-sticky-atc__name';
    n.textContent = name;
    var meta = document.createElement('span');
    meta.className = 'dk-sticky-atc__meta';
    var metaColour = document.createElement('span');
    metaColour.textContent = colour ? colour + ' · ' : '';
    var metaPrice = document.createElement('span');
    metaPrice.className = 'dk-sticky-atc__price';
    metaPrice.textContent = mainButton.dataset.dkPrice || '';
    meta.appendChild(metaColour);
    meta.appendChild(metaPrice);
    info.appendChild(n);
    info.appendChild(meta);

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'button button--primary';
    cta.tabIndex = -1;
    cta.textContent = mainButton.disabled
      ? ((window.variantStrings && window.variantStrings.soldOut) || 'Sold out')
      : 'Select size';

    cta.addEventListener('click', function () {
      var picker = mainInfo.querySelector('variant-radios, variant-selects, .globo-swatch-product-detail, product-form');
      var target = picker || mainButton;
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var firstInput = target.querySelector && target.querySelector('input:checked, select, input');
      if (firstInput) {
        setTimeout(function () { firstInput.focus({ preventScroll: true }); }, 400);
      }
    });

    bar.appendChild(info);
    bar.appendChild(cta);
    document.body.appendChild(bar);

    if (!('IntersectionObserver' in window)) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        cta.tabIndex = passed ? 0 : -1;
      });
    });
    observer.observe(mainButton);
  }

  /* ---------- 3. Header offsets for full-height hero + sticky split titles ---------- */
  function initHeaderOffsets() {
    var root = document.documentElement;
    var header = document.querySelector('.section-header, [id$="__header"].shopify-section');
    var groups = document.querySelectorAll('.shopify-section-group-header-group');
    var ticking = false;

    function total() {
      var h = 0;
      groups.forEach(function (g) { h += g.offsetHeight; });
      return h;
    }

    function update() {
      ticking = false;
      root.style.setProperty('--dk-header-h', total() + 'px');
      root.style.setProperty('--dk-scrollbar', Math.max(0, window.innerWidth - document.documentElement.clientWidth) + 'px');
      var visible = 0;
      if (header) {
        visible = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
      }
      root.style.setProperty('--dk-header-visible', visible + 'px');
    }

    function request() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    update();
    window.addEventListener('resize', request);
    window.addEventListener('scroll', request, { passive: true });
  }

  /* ---------- 4. Reviews next to the price ---------- */
  var REVIEW_SELECTORS = [
    '[id^="shopify-block-"][id*="rating"]',
    '[id^="shopify-block-"][id*="review"]',
    '.klaviyo-star-rating-widget',
    '.loox-rating',
    '.jdgm-preview-badge',
    '.yotpo.bottomLine',
    '[data-oke-star-rating]',
    '.stamped-product-reviews-badge',
    '.spr-badge'
  ].join(',');

  /* Templates whose price block was saved before this update have no slot: build one around the price */
  function ensureReviewSlots() {
    document.querySelectorAll('product-info').forEach(function (info) {
      if (info.querySelector('[data-dk-reviews-slot]')) return;
      var price = info.querySelector('[id^="price-"]') || info.querySelector('.dk-pdp-title__price');
      if (!price || !price.parentNode) return;
      var row = document.createElement('div');
      row.className = 'dk-price-row';
      price.parentNode.insertBefore(row, price);
      row.appendChild(price);
      price.classList.add('dk-price-row__price');
      var slot = document.createElement('div');
      slot.className = 'dk-price-row__reviews';
      slot.setAttribute('data-dk-reviews-slot', '');
      row.appendChild(slot);
    });
  }

  function initReviewSlots() {
    ensureReviewSlots();
    document.querySelectorAll('[data-dk-reviews-slot]').forEach(function (slot) {
      if (slot.childElementCount) return;
      var info = slot.closest('product-info') || slot.closest('.product__info-container');
      if (!info) return;
      var found = null;
      info.querySelectorAll(REVIEW_SELECTORS).forEach(function (el) {
        if (found || slot.contains(el)) return;
        found = el.closest('.shopify-app-block, .shopify-block') || el;
      });
      if (!found || found.contains(slot)) return;
      slot.appendChild(found);
      slot.classList.add('is-filled');
      /* Clicking the stars scrolls to the full reviews section when there is one */
      if (!found.querySelector('a')) {
        found.style.cursor = 'pointer';
        found.addEventListener('click', function () {
          var target = document.querySelector('[id*="reviews-app-section"], [id*="product-reviews"], #looxReviews, .klaviyo-reviews-widget, .jdgm-review-widget');
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    });
  }

  /* ---------- 5. EU / US size switch on the product page ---------- */
  function readUnit() {
    try { return localStorage.getItem('dkSizeUnit') === 'US' ? 'US' : 'EU'; } catch (e) { return 'EU'; }
  }
  function saveUnit(unit) {
    try { localStorage.setItem('dkSizeUnit', unit); } catch (e) { /* storage blocked */ }
  }
  function applyUnit(fieldset, unit) {
    var us = unit === 'US';
    fieldset.classList.toggle('dk-show-us', us);
    var sw = fieldset.querySelector('[data-dk-size-unit]');
    if (sw) {
      sw.classList.toggle('is-on', us);
      sw.setAttribute('aria-checked', us ? 'true' : 'false');
    }
  }
  function initSizeUnits() {
    var unit = readUnit();
    document.querySelectorAll('[data-dk-size-fieldset]').forEach(function (fs) { applyUnit(fs, unit); });
  }

  /* ---------- 6. Size guide drawer ---------- */
  function openSizeGuide(dialog) {
    if (typeof dialog.showModal !== 'function') return false;
    dialog.showModal();
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () { dialog.classList.add('is-open'); });
    return true;
  }
  function closeSizeGuide(dialog) {
    dialog.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden');
    setTimeout(function () { if (dialog.open) dialog.close(); }, 250);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var sw = e.target.closest('[data-dk-size-unit]');
    if (sw) {
      e.preventDefault();
      var unit = sw.classList.contains('is-on') ? 'EU' : 'US';
      saveUnit(unit);
      document.querySelectorAll('[data-dk-size-fieldset]').forEach(function (fs) { applyUnit(fs, unit); });
      return;
    }

    var guide = e.target.closest('[data-dk-size-guide]');
    if (guide) {
      var dialog = document.getElementById(guide.dataset.dkSizeGuide);
      if (dialog && openSizeGuide(dialog)) e.preventDefault();
      return;
    }

    var closeBtn = e.target.closest('[data-dk-size-guide-close]');
    if (closeBtn) {
      closeSizeGuide(closeBtn.closest('dialog'));
      return;
    }

    /* Click on the dim backdrop (the dialog itself, outside the panel) */
    if (e.target.matches && e.target.matches('dialog.dk-sg')) closeSizeGuide(e.target);
  });

  document.addEventListener('cancel', function (e) {
    if (e.target.matches && e.target.matches('dialog.dk-sg')) {
      e.preventDefault();
      closeSizeGuide(e.target);
    }
  }, true);

  /* ---------- 7. GLO / Globo colour swatch app: EU / US switch + size guide on its size buttons ---------- */
  var US_SIZES = {
    35: '4.5-5', 36: '5.5-6', 37: '6.5-7', 38: '7.5-8', 39: '8.5-9', 40: '9.5-10',
    41: '10.5-11', 42: '11.5-12', 43: '12.5-13',
    44: 'M 11.5-12', 45: 'M 12.5-13', 46: 'M 13.5-14', 47: 'M 14.5-15'
  };

  function euNumber(value) {
    var m = String(value || '').trim().match(/^(\d{2})\s*(eu)?$/i);
    if (!m) return null;
    var n = Number(m[1]);
    return n >= 35 && n <= 47 ? n : null;
  }

  function sizeHeadHtml(name, withSwitch, guideId) {
    return '<span class="form__label dk-size-head__label" aria-hidden="true">Select ' + name + '</span>' +
      (withSwitch
        ? '<span class="dk-size-head__units"><span class="dk-size-head__unit">EU</span>' +
          '<button type="button" class="dk-qs__switch" role="switch" aria-checked="false" aria-label="Show US sizes" data-dk-size-unit><span></span></button>' +
          '<span class="dk-size-head__unit">US</span></span>'
        : '') +
      '<a class="dk-size-head__guide" href="' + (guideId ? '#' + guideId : '/pages/size-guide') + '" aria-haspopup="dialog"' +
      (guideId ? ' data-dk-size-guide="' + guideId + '"' : '') + '>Size guide</a>';
  }

  function enhanceGloboSwatches(root) {
    var dialog = document.querySelector('dialog.dk-sg');
    var guideId = dialog ? dialog.id : '';
    (root || document).querySelectorAll('.globo-swatch-product-detail .swatch--gl').forEach(function (group) {
      var legend = group.querySelector('.name-option');
      var list = group.querySelector('ul.value');
      if (!legend || !list) return;
      var name = (legend.getAttribute('data-name') || legend.textContent.split(':')[0] || '').trim();
      var isSize = /size/i.test(name);
      group.classList.add('dk-globo-group', isSize ? 'dk-globo-group--size' : 'dk-globo-group--pills');
      if (!isSize) return;

      var items = Array.prototype.slice.call(list.querySelectorAll('li[data-value]'));
      var euUs = items.length > 0 && items.every(function (li) { return euNumber(li.getAttribute('data-value')) !== null; });

      if (!group.querySelector('.dk-size-head')) {
        var head = document.createElement('div');
        head.className = 'dk-size-head';
        head.innerHTML = sizeHeadHtml(name, euUs, guideId);
        list.parentNode.insertBefore(head, list);
      }

      if (euUs) {
        group.setAttribute('data-dk-size-fieldset', '');
        items.forEach(function (li) {
          var label = li.querySelector('label');
          if (!label || label.querySelector('.dk-size-eu')) return;
          var n = euNumber(li.getAttribute('data-value'));
          label.innerHTML = '<span class="dk-size-eu">' + n + '</span><span class="dk-size-us">' + (US_SIZES[n] || n) + '</span>';
        });
        applyUnit(group, readUnit());
      }
    });
  }

  function initGloboSwatches() {
    enhanceGloboSwatches();
    if (!('MutationObserver' in window)) return;
    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        enhanceGloboSwatches();
      });
    });
    document.querySelectorAll('product-info, .product__info-container').forEach(function (info) {
      observer.observe(info, { childList: true, subtree: true });
    });
  }

  /* ---------- 8. Product gallery: vertical thumbnail column (gallery layout "Thumbnails") ---------- */
  function initGallery() {
    document.querySelectorAll('media-gallery[data-desktop-layout="thumbnail"]').forEach(function (gallery) {
      if (gallery.dataset.dkThumbs) return;
      var list = gallery.querySelector('.thumbnail-list');
      if (!list) return;
      gallery.dataset.dkThumbs = 'true';
      var up = gallery.querySelector('[data-dk-thumbs="-1"]');
      var down = gallery.querySelector('[data-dk-thumbs="1"]');

      function update() {
        var scrollable = list.scrollHeight - list.clientHeight > 2;
        if (up) up.hidden = !scrollable || list.scrollTop <= 2;
        if (down) down.hidden = !scrollable || list.scrollTop + list.clientHeight >= list.scrollHeight - 2;
      }

      [up, down].forEach(function (btn) {
        if (!btn) return;
        btn.addEventListener('click', function () {
          list.scrollBy({ top: Number(btn.dataset.dkThumbs) * list.clientHeight * 0.8, behavior: 'smooth' });
        });
      });

      /* Keep the selected thumbnail in view (Dawn only scrolls sideways) */
      list.addEventListener('click', function (e) {
        var item = e.target.closest && e.target.closest('.thumbnail-list__item');
        if (!item) return;
        var top = item.offsetTop - list.offsetTop;
        if (top < list.scrollTop || top + item.offsetHeight > list.scrollTop + list.clientHeight) {
          list.scrollTo({ top: Math.max(0, top - item.offsetHeight), behavior: 'smooth' });
        }
      });

      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(list);
      gallery.querySelectorAll('img').forEach(function (img) { if (!img.complete) img.addEventListener('load', update, { once: true }); });
      update();
    });
  }

  function safe(fn) {
    try { fn(); } catch (e) { if (window.console) console.warn('[dansko-us]', e); }
  }

  function init() {
    /* Each part runs on its own, so one failing never stops the others */
    safe(initHeaderOffsets);
    safe(initAtcLabels);
    safe(listenForVariantChange);
    safe(initStickyAtc);
    safe(initReviewSlots);
    safe(initSizeUnits);
    safe(initGloboSwatches);
    safe(initGallery);
    /* Review apps can render their star block late: keep trying for a few seconds */
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      safe(initReviewSlots);
      var waiting = document.querySelector('[data-dk-reviews-slot]:not(.is-filled)');
      if (!waiting || tries > 20) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Some review apps inject their block late */
  window.addEventListener('load', function () { safe(initReviewSlots); safe(enhanceGloboSwatches); });

  /* Theme editor re-renders sections */
  document.addEventListener('shopify:section:load', function () {
    safe(initReviewSlots);
    safe(initSizeUnits);
    safe(initAtcLabels);
    safe(enhanceGloboSwatches);
    safe(initGallery);
  });

  /* Quick-add modals render a product form after load */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('modal-opener')) {
      setTimeout(function () { initAtcLabels(); initSizeUnits(); }, 1200);
    }
  });
})();
